// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2cyH9","list":"styles_list__1LPMD"};